import { employeeProfileEdit } from '../../../../i18n/translatedMessages';

export const Address = ({ onChange, data, error, lists }) => {
  return (
    <div className="content-form">
      <div className="row">
        <div className="col">
          <h3>Informaciones de Domicílo</h3>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="city">Ciudad</label>
          <input type="text" id="city" name="city" onChange={onChange} value={data.city || ''} className={error.city ? 'error' : ''} />
          {error.city && <small>{employeeProfileEdit.profileError}</small>}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="label">País</div>
          <select name="country" onChange={onChange} className={error.country ? 'error' : ''} value={data.country || ''}>
            <option value="" style={{ color: '#AFAFAF' }}>
              País
            </option>
            {lists?.country.map((country) => (
              <option value={country.id} key={country.id}>
                {country.name}
              </option>
            ))}
          </select>
          {error.boss && <small>{employeeProfileEdit.profileError}</small>}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="address">Dirección</label>
          <input type="text" id="address" name="address" onChange={onChange} value={data.address || ''} />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="nationality">Nacionalidad</label>
          <input type="text" id="nationality" name="nationality" onChange={onChange} value={data.nationality || ''} />
        </div>
      </div>
    </div>
  );
};
